import React, { useEffect, useState } from 'react';
// import dayjs from 'dayjs';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import Skeleton from '@mui/material/Skeleton';
import Record from './TableDetail/Record';

import { getToken } from 'src/utils/auth';
import { getAPI } from 'src/utils/api';
import { formatNumber, getField } from 'src/common/helper';

const titleFont = { fontSize: '12px', lineHeight: '14.4px', fontWeight: 400, color: '#00000080' };
const contentFont = { fontSize: '14px', lineHeight: '16.8px', fontWeight: 500, color: '#484848' };

const sizeSkeleton = {
  width: '100px'
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

interface DialogDetailProps {
  open: boolean;
  id: number;
  onClose: (isRefreshList?: boolean) => void;
};

const DialogDetail: React.FC<DialogDetailProps> = (props) => {
  const [detailData, setDetailData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const getDetail = () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      setLoading(true);
      getAPI(`/master/stock-view?id=${props.id}&token=${token}`)
        .then((res: any) => {
          if (res.code === 200 && res.data && res.data.product) {
            setDetailData(res.data.product);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  }

  const handleClose = () => {
    props.onClose();
  };

  useEffect(() => {
    if (props.open) {
      getDetail();
    }
    // eslint-disable-next-line
  }, [props.open]);

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      slotProps={{ backdrop: { invisible: true } }}
      TransitionComponent={Transition}
      sx={{
        position: 'fixed !important',
        top: '0px !important',
        right: '0px !important',
        left: 'auto',
        bottom: 'auto',
        p: '0px',
        zIndex: 2147483647,
        '& .MuiDialog-paper': {
          m: '0px !important',
          width: '100%',
          maxWidth: '713px',
          height: '100vh',
          bgcolor: '#FAFDFF',
          borderRadius: '16px 0px 0px 16px',
        }
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '16px' }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Box alignContent={'center'}>
            <Typography sx={{ fontSize: '14px', lineHeight: '16px', fontWeight: 700 }}>
              在庫詳細
            </Typography>
          </Box>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '20px', height: '20px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0px 10px 16px 16px',
          overflow: 'hidden'
        }}
      >

        <Stack spacing='15px'>
          <Box>
            <Typography sx={{ ...titleFont }}>
              品名
            </Typography>
            {loading ? (
              <Skeleton animation='wave' sx={sizeSkeleton} />
            ) : (
              <Typography sx={{ ...contentFont }}>
                {getField(detailData, 'product')}
              </Typography>
            )}
          </Box>

          <Box>
            <Typography sx={{ ...titleFont }}>
              在庫数
            </Typography>
            {loading ? (
              <Skeleton animation='wave' sx={sizeSkeleton} />
            ) : (
              <Typography sx={{ ...contentFont }}>
                {getField(detailData, 'balance')}
              </Typography>
            )}
          </Box>

          <Box>
            <Typography sx={{ ...titleFont }}>
              価格
            </Typography>
            {loading ? (
              <Skeleton animation='wave' sx={sizeSkeleton} />
            ) : (
              <Typography sx={{ ...contentFont }}>
                ¥{formatNumber(getField(detailData, 'price', 0))}
              </Typography>
            )}
          </Box>

          <Divider />

          <Box sx={{ width: '100%' }}>
            <Record
              items={getField(detailData, 'records', [])}
              loading={loading}
            />
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DialogDetail;
